export default {
    /* global fbq */
    install(Vue, options) {
        Vue.prototype.$fbq = function(eventName, eventParams) {
            if (typeof fbq !== "undefined") {
                fbq("track", eventName, eventParams);
            }
        };
        // // 获取 URL 中的 fid 参数值
        // function getFidFromUrl(url) {
        //     const match = url.match(/[?&]fid=([^&#]*)/);
        //     return match ? match[1] : null;
        // }
        // const url = location.href
        // const fid = getFidFromUrl(url);
        // console.log(fid);

        // // 在此处替换为您的Pixel ID
        // const pixelId = location.href
        // console.log(pixelId);


        (function(f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function() {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
        // fbq("init", pixelId);
        // fbq("track", 'PageView');
    },
};